import React, { useEffect, useState } from 'react';

const DropdownMenu = ({ selectedIndex, items, onSelect, selectText }) => {
    const [internalIndex, setInternalIndex] = useState(selectedIndex || null);

    useEffect(() => {
        setInternalIndex(selectedIndex);
    }, [selectedIndex]);

    const handleChange = (e) => {
        const index = parseInt(e.target.value, 10);
        setInternalIndex(index);
        if (onSelect) onSelect(items[index]);
    };

    return (
        <select
            value={internalIndex !== null ? internalIndex : ''}
            onChange={handleChange}
            className="form-select appearance-none block w-full px-3 py-1.5 text-base font-semibold text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >
            <option value="" disabled className='text-gray-900'>
                {selectText || 'Select an item'}
            </option>
            {items?.map((item, index) => (
                <option key={index} value={index} className='font-medium'>
                    {item.filename}
                </option>
            ))}
        </select>
    );
};

export default DropdownMenu;
